import axios from 'axios';
import {MessageBox, Message} from 'element-ui'
import router from "../router";
import myStorage from "./utils";
import {debounce} from "./utils";

const http = axios.create({
  withCredentials: true,
  // headers: {
  //   // 'Content-Type': 'application/json;charset=utf-8',
  //   'Content-Type': 'application/x-www-form-urlencoded',
  // },
});

// 添加请求拦截器
http.interceptors.request.use((config) => {
    // 在发送请求之前做些什么
    const token = myStorage.getItem('localStorage','token')
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers['token'] = token;
    }else {
      const accountid=localStorage.getItem('accountid')
      const tokens=localStorage.getItem('tokens')
      if(accountid&&tokens){
        config.headers['token'] = tokens;
      }
    }
    return config;
  }, error =>
    // 对请求错误做些什么
    Promise.reject(error),
);

// 添加响应拦截器
// eslint-disable-next-line consistent-return
http.interceptors.response.use((response) => {
    // 对响应数据做点什么
    // const res = response.data;
    // if (res.result === 'success') {
    //   return response;
    // }

  return response
    // window.console.log(response);
  }, error =>
    // 对响应错误做点什么
    Promise.reject(error),
);

let debounceone=null
let debouncetwo=null

function apiAxios(method, url, params, response,Contenttype) {
  let ctype='application/x-www-form-urlencoded'
  if(Contenttype=='json'){
    ctype='application/json;charset=utf-8'
  }else if(Contenttype){
    ctype=Contenttype
  }
  http({
    method,
    url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    headers:{
      'Content-Type': ctype
    }
  }).then((res) => {
    if(res.data.code*1 >=100000) {
      // if(debounceone){
      //   debounceone()
      // }else {
      //   debounceone=debounce(() => {

      //   }, 500)
      //   debounceone()
      // }
      Message({
        message: res.data.message || '系统错误，请稍后再操作！',
        type: 'error',
        duration: 5 * 1000
      })
      let hash = window.location.hash.split('/')[1]
      if(hash != 'register' && hash !='ale') {
        loginout(res.data)
      }
    }
    if (res.headers['token']) { //控制token失效刷新
      myStorage.setItem('localStorage','token', res.headers['token'])
    }
    response(res);
  }).catch((err) => {
    if (err.response.data) {
      loginout(err.response.data)
      Message({
            message: err.response.data.msg||err.message+'：系统错误，请稍后再操作！',
            type: 'error',
            duration: 5 * 1000
          })
      // if(debouncetwo){
      //   debouncetwo()
      // }else {
      //   debouncetwo=debounce(() => {

      //   }, 500)
      //   debouncetwo()
      // }
    }
    window.console.log(err)
  })
}

function loginout(data) {
  if (data.code == '100000'){
    localStorage.removeItem('userinfo')
    localStorage.removeItem('token')
    localStorage.removeItem('accountid')
    localStorage.removeItem('tokens')
    router.push('/login')
  }
  if (data.code == '102000') {
    router.replace('/homepage')
  }
}

export default {
  get(url, params, response,Contenttype) {
    return apiAxios('GET', url, params, response,Contenttype);
  },
  post(url, params, response,Contenttype) {
    return apiAxios('POST', url, params, response,Contenttype);
  },
  // put: function (url, params, response) {
  //   return apiAxios('PUT', url, params, response)
  // },
  // delete: function (url, params, response) {
  //   return apiAxios('DELETE', url, params, response)
  // },
};



// WEBPACK FOOTER //
// ./src/bll/axiosapi.js